import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import UserAddressDisplay from './UserAddressDisplay';
import EditIcon from '../../icons/EditIcon';
import TrashIcon from '../../icons/TrashIcon';

const propTypes = {
  address: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string,
  onDelete: PropTypes.func,
  className: PropTypes.string,
  addressClassName: PropTypes.string,
};

const UserAddressDisplayEditBox = ({
  address,
  onClick,
  title,
  onDelete,
  className,
  addressClassName,
}) => {
  const classes = classNames({
    'user-address-info-edit-box': true,
    [className]: !!className,
  });

  const addressClasses = classNames({
    [addressClassName]: !!addressClassName,
  });

  return (
    <a
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick?.();
      }}
      href="#"
    >
      {onClick && (
        <span className="user-address-btn-edit">
          <EditIcon size="15px" />
        </span>
      )}
      {onDelete && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <span
          className="user-address-btn-delete"
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            onDelete(address.id);
          }}
          role="button"
          tabIndex={-1}
        >
          <TrashIcon color="#0d84fe" />
        </span>
      )}
      <UserAddressDisplay
        address={address}
        title={title}
        className={addressClasses}
      />
    </a>
  );
};

UserAddressDisplayEditBox.propTypes = propTypes;

export default UserAddressDisplayEditBox;
